import { merge } from 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const simplePubsub = (initialState) => {
  let state = initialState || {};
  const listeners = {};
  const subscribe = (key, callback) => {
    if (typeof callback !== "function") {
      throw "Callback for key " + key + " is not a function";
    }
    listeners[key] = listeners[key] || [];
    listeners[key].push(callback);
    return () => {
      listeners[key] = listeners[key].filter((listener) => listener !== callback);
    };
  };
  const unsubscribe = (key, callback) => {
    if (listeners[key]) {
      listeners[key] = listeners[key].filter((listener) => listener !== callback);
    }
  };
  const subscribeOnBlock = ({
    key,
    blockKey = state.focusedBlock,
    callback
  }) => {
    return subscribe(blockHandlerKey(key, blockKey), callback);
  };
  const update = (key, newData, blockKey) => {
    const data = get(key);
    const newItem = merge({}, data, newData);
    blockKey ? _setSingle(key, newItem, blockKey) : set(key, newItem);
  };
  const _setSingle = (key, item, blockKey) => {
    state = __spreadProps(__spreadValues({}, state), {
      [key]: item
    });
    if (listeners[key]) {
      listeners[key].forEach((listener) => listener(state[key], blockKey));
    }
  };
  const _setBatch = (updates) => {
    state = __spreadValues(__spreadValues({}, state), updates);
    Object.keys(updates).forEach((key) => {
      if (listeners[key]) {
        listeners[key].forEach((listener) => listener(state[key]));
      }
    });
  };
  const set = (...args) => {
    if (args.length === 1) {
      _setBatch(args[0]);
    } else {
      _setSingle(...args);
    }
  };
  const setBlockHandler = (key, blockKey, item) => {
    _setSingle(blockHandlerKey(key, blockKey), item);
  };
  const setBlockData = ({
    key,
    blockKey = state.focusedBlock,
    item
  }) => {
    _setSingle(blockHandlerKey(key, blockKey), item);
  };
  const get = (key) => state[key];
  const getBlockHandler = (key, blockKey = state.focusedBlock) => {
    return state[blockHandlerKey(key, blockKey)];
  };
  const getBlockData = ({
    key,
    blockKey = state.focusedBlock
  }) => {
    return state[blockHandlerKey(key, blockKey)];
  };
  const blockHandlerKey = (key, blockKey) => `${blockKey}_${key}`;
  const store = {
    get,
    getBlockHandler,
    update,
    set,
    setBlockHandler
  };
  return {
    subscribe,
    unsubscribe,
    update,
    set,
    setBlockHandler,
    get,
    getBlockHandler,
    store,
    getBlockData,
    setBlockData,
    subscribeOnBlock
  };
};

export { simplePubsub };
//# sourceMappingURL=simplePubsub.js.map
